<template>
  <Modal
    ref="inviteUserModal"
    :showCloseBtn="true"
    :afterCloseModal="afterCloseModal"
    modalType="medium-modal"
  >
    <div slot="modal-header">
      <p
        class="title"
        v-html="title"
      />
    </div>
    <div slot="content">
      <slot name="content">
        <label class="text font-bold">{{ $t('user.usernameEmailAddress') }}</label>
        <HKLSelect
          ref="multiSelect"
          :value="value"
          :options="hklOptions"
          :showSearch="true"
          placeholder=""
          @change="addUserById"
        />
        <div>
          <SimpleTable
            ref="usersToBeInvited"
            class="simple-table"
            :removable="true"
            :headers="candidateTableHeaders"
            @removeRow="removeUser"
          />
        </div>
      </slot>
    </div>
    <div slot="btns">
      <button
        type="button"
        class="btn btn--darkblue"
        @click="cancel()"
      >
        {{ cancelBtnName }}
      </button>
      <button
        type="button"
        class="btn btn--orange"
        :disabled="scopedCandidates.length === candidates.length"
        @click="invite()"
      >
        {{ inviteBtnName }}
      </button>
    </div>
  </Modal>
</template>

<script>
import { computed, ref, unref } from 'vue-demi'
import lodash from 'lodash'
import Modal from '@/controls/Modal'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import i18n from '@/utils/i18n'
import SimpleTable from '@/controls/SimpleTable'
import userHelper from '@/utils/userHelper'
import { inviteUserToRegion } from '@/api/users/request'
import formFullnameMixin from '@/pages/formFullnameMixin'

export default {
  name: 'InviteUserModal',
  components: {
    HKLSelect,
    Modal,
    SimpleTable,
  },
  mixins: [formFullnameMixin],
  props: {
    title: {
      type: String,
      default: i18n.t('user.inviteUser'),
    },
    cancelBtnName: {
      type: String,
      default: i18n.t('action.cancel'),
    },
    inviteBtnName: {
      type: String,
      default: i18n.t('action.invite'),
    },
  },
  setup () {
    const scopedCandidates = ref([])
    const options = computed(() => {
      return unref(scopedCandidates).sort((a, b) => a.username.localeCompare(b.username))
    })
    const hklOptions = computed(() => {
      return unref(options).map((user) => ({
        name: user.username,
        value: user.AD_id,
      }))
    })
    return {
      hklOptions,
      options,
      scopedCandidates,
    }
  },
  data () {
    return {
      value: undefined,
      candidates: [],
      candidateTableHeaders: [
        {text: i18n.t('user.name'), label: 'fullName'},
        {flex: 2, text: i18n.t('user.email'), label: 'username'},
        {text: i18n.t('user.phone'), label: 'phone'},
      ],
    }
  },
  methods: {
    removeUser (user) {
      this.scopedCandidates.push(user)
    },
    addUser (user) {
      this.$refs.usersToBeInvited.addContent(user)
      const index = this.scopedCandidates.findIndex(sc => sc.username === user.username)
      this.scopedCandidates.splice(index, 1)
      this.$nextTick(() => { this.value = undefined })
    },
    addUserById (adId) {
      const user = this.scopedCandidates.find(candidate => candidate.AD_id === adId)
      if (user) {
        this.addUser(user)
      }
    },
    open (candidates) {
      this.scopedCandidates = lodash.cloneDeep(candidates)
        .map(item => ({
          fullName: userHelper.getUserName(item.username, item.displayName) || this.displayI18nFullName(item.firstName, item.lastName),
          ...item,
        }))
      this.candidates = candidates
      this.$refs.inviteUserModal.open()
    },
    cancel () {
      this.$refs.inviteUserModal.close()
      this.afterCloseModal()
    },
    afterCloseModal () {
      this.scopedCandidates = lodash.cloneDeep(this.candidates)
      this.$refs.usersToBeInvited.emptyContents()
    },
    async invite () {
      const usersToBeInvited = this.$refs.usersToBeInvited.getContents()
      const adIds = usersToBeInvited.map(user => user.AD_id)
      if (adIds.length === 0) return // @TODO @doubley_yang return tips
      await inviteUserToRegion(adIds)

      this.$refs.inviteUserModal.close()
      this.$refs.usersToBeInvited.emptyContents()

      location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
}
.simple-table {
  margin-top: 10px;
}
</style>
